
import React, { useState } from 'react';
import { useAuth } from './AuthContext';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
//import logoUrl from '../../pawafleet-logo-light.svg';
import logoUrl from '../assets/logo.jpg';

const Login = () => {
    const { rootUrl } = require('../../config/config');
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [requires2FA, setRequires2FA] = useState(false);
    const [challengeId, setChallengeId] = useState(null);
    const [verificationCode, setVerificationCode] = useState('');
    const [error, setError] = useState(null);
    const { login } = useAuth();
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault(); // Prevent default form submission
        setError(null);
        try {
            const response = await axios.post(`${rootUrl}/login`,
                JSON.stringify({ username, password }),
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                }
            );

            if (response.data?.requires2FA) {
                setRequires2FA(true);
                setChallengeId(response.data.challengeId);
                setError(null);
                return;
            }

            const { accessToken, refreshToken, name, profile_picture, actor_type } = response.data;

            login(accessToken, refreshToken, name, profile_picture);
            if (actor_type === 'driver') navigate('/driver/dashboard');
            else if (actor_type === 'owner') navigate('/owner/dashboard');
            else navigate('/');
        } catch (error) {
            setError('Invalid username or password');
            console.error('Login error:', error);
        }
    };

    const handleVerify2FA = async (e) => {
        e.preventDefault();
        setError(null);

        if (!verificationCode.trim()) {
            setError('Verification code is required');
            return;
        }

        try {
            const response = await axios.post(
                `${rootUrl}/login/verify-2fa`,
                JSON.stringify({ challengeId, code: verificationCode }),
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                }
            );

            const { accessToken, refreshToken, name, profile_picture, actor_type } = response.data;

            login(accessToken, refreshToken, name, profile_picture);
            if (actor_type === 'driver') navigate('/driver/dashboard');
            else if (actor_type === 'owner') navigate('/owner/dashboard');
            else navigate('/');
        } catch (error) {
            setError(error.response?.data?.error || 'Invalid verification code');
        }
    };

    return (
        <section className="flex items-center justify-center min-h-screen p-2 bg-gray-100">
            <div className="w-full max-w-sm p-6 bg-white rounded shadow-md">
                <div className="flex w-full justify-center mb-6">
                    <img
                        src={logoUrl}
                        alt="PAWAFLEET"
                        className="h-32 w-auto object-contain mx-auto"
                    />
                </div>
                <h2 className="mb-4 text-2xl font-bold text-center">Login</h2>
                {error && <div className="mb-4 text-red-500">{error}</div>}
                <form onSubmit={requires2FA ? handleVerify2FA : handleLogin}>
                    {!requires2FA && (
                        <>
                            <input
                                type="text"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                placeholder="Username"
                                autoComplete="off"
                                className="w-full px-3 py-2 mb-4 border rounded focus:outline-none focus:ring focus:ring-blue-500"
                            />
                            <input
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="Password"
                                autoComplete="off"
                                className="w-full px-3 py-2 mb-4 border rounded focus:outline-none focus:ring focus:ring-blue-500"
                            />
                        </>
                    )}

                    {requires2FA && (
                        <>
                            <div className="mb-4 text-sm text-gray-600">
                                Enter the verification code sent to your email.
                            </div>
                            <input
                                type="text"
                                value={verificationCode}
                                onChange={(e) => setVerificationCode(e.target.value)}
                                placeholder="Verification code"
                                autoComplete="one-time-code"
                                className="w-full px-3 py-2 mb-4 border rounded focus:outline-none focus:ring focus:ring-blue-500"
                            />
                        </>
                    )}

                    <button
                        type="submit"
                        className="w-full px-4 py-2 font-semibold text-white bg-blue-500 rounded hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-500"
                    >
                        {requires2FA ? 'Verify Code' : 'Login'}
                    </button>
                </form>
                <div className="mt-4 text-center">

                    <p>
                        <Link to="/forgot-password" className="text-blue-500 hover:underline">Forgot Password?</Link>
                    </p>
                </div>
            </div>
        </section>
    );
};

export default Login;
